/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './CallToAction.scss';

import { string } from 'prop-types';
import React from 'react';

import { contentConverter } from 'services/Content';
import { transformMessageText } from 'state/IRT/IRTMessagesReducer';

const CallToAction = ({
  messageName = '',
  messageText = '',
  isMarketingTest,
  messageId = ''
}) => {
  if (messageName && messageText) {
    return (
      <div className="dashboard-call-to-action-container">
        <span
          className="dashboard-call-to-action-title"
          dangerouslySetInnerHTML={{
            __html: contentConverter.makeHtml(messageName)
          }}
        />

        <span
          className="dashboard-call-to-action-body"
          dangerouslySetInnerHTML={{
            __html: contentConverter.makeHtml(
              isMarketingTest
                ? transformMessageText(messageText, messageId)
                : messageText
            )
          }}
        />
      </div>
    );
  }

  return null;
};

CallToAction.propTypes = {
  messageName: string,
  messageText: string,
  mboxContainer: string
};

export default CallToAction;
